const paymentTypes = {
  STRIPE: 1,
  PAYPAY: 2,
  ONEPAY_ALIPAY: 3,
  ONEPAY_LINEPAY: 4,
  ONEPAY_MERUPAY: 5,
  WECHATPAY: 6,
  VERITRANS: 7,
  ATONE: 8
};

export const onePayEnabled = true;
export const wechatPayEnabled = false;

export default paymentTypes;
